import { articelsHomePageImages } from "../../services/images.service"
import { GreyBorderBottom } from "../ui/elements"

export function AnimeDirectorMobile({anime}) {
    return (
        <div>
    {anime.directors && anime.directors.length > 0 && (
        <div className="">
          <div className="mb-4">
            <h5>מפיקים</h5>
       <GreyBorderBottom className="w-full" />
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-2">
            {anime.directors.map((director) => (
              <div
                key={director.staff_mal_id || index}
                className="flex items-center gap-2"
              >
                <img
                  src={director.image}
                  alt={director.name}
                  className="w-10 h-16 object-cover"
                />
                <div className="flex flex-col">
                  <p className="w-full">{director.name}</p>
                  <p className="text-gray-400 text-sm">
                    {director.positions.join(', ')}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
        </div>
    )
}